import HolidayCalendar from "../../entities/holidayCalendar";

/**
 * HolidayCalendar actions
 *
 * Call order:
 *
 * HOLIDAYCALENDAR_SAVE_QUEUE:	adds the item to the save queue
 * --> HOLIDAYCALENDAR_SAVE:	modifies the state
 * --> HOLIDAYCALENDAR_SAVE_SUCCESS: if all went well
 * --> HOLIDAYCALENDAR_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail HOLIDAYCALENDAR_SAVE_QUEUE is during the call to HOLIDAYCALENDAR_SAVE,
 * as adding an item to the queue should never fail.
 *
 * OWA-1018: the reducer shows a queued save at HOLIDAYCALENDAR_SAVE_QUEUE, marked pending, and only that
 * save's own outcome settles the mark: HOLIDAYCALENDAR_SAVE_SUCCESS, HOLIDAYCALENDAR_SAVE_REVERT (refused, or
 * never queued), a refusal the queue never retries, or HOLIDAYCALENDAR_PENDING_CHECK (it left the queue).
 */

export const HOLIDAYCALENDAR_FETCH_ONE_QUEUE: any = 'HOLIDAYCALENDAR_FETCH_ONE_QUEUE';
export const HOLIDAYCALENDAR_FETCH_SUCCESS: any = 'HOLIDAYCALENDAR_FETCH_SUCCESS';
export const HOLIDAYCALENDAR_FETCH_FAILURE: any = 'HOLIDAYCALENDAR_FETCH_FAILURE';
export const HOLIDAYCALENDAR_FETCH_ONE_SUCCESS: any = 'HOLIDAYCALENDAR_FETCH_ONE_SUCCESS';
export const HOLIDAYCALENDAR_FETCH_ONE_FAILURE: any = 'HOLIDAYCALENDAR_FETCH_ONE_FAILURE';

export const HOLIDAYCALENDAR_SAVE: any = 'HOLIDAYCALENDAR_SAVE';
export const HOLIDAYCALENDAR_SAVE_QUEUE: any = 'HOLIDAYCALENDAR_SAVE_QUEUE';
export const HOLIDAYCALENDAR_SAVE_SUCCESS: any = 'HOLIDAYCALENDAR_SAVE_SUCCESS';
export const HOLIDAYCALENDAR_SAVE_FAILURE: any = 'HOLIDAYCALENDAR_SAVE_FAILURE';

export const HOLIDAYCALENDAR_SAVE_MANY: any = 'HOLIDAYCALENDAR_SAVE_MANY';
export const HOLIDAYCALENDAR_SAVE_MANY_QUEUE: any = 'HOLIDAYCALENDAR_SAVE_MANY_QUEUE';
export const HOLIDAYCALENDAR_SAVE_MANY_SUCCESS: any = 'HOLIDAYCALENDAR_SAVE_MANY_SUCCESS';
export const HOLIDAYCALENDAR_SAVE_MANY_FAILURE: any = 'HOLIDAYCALENDAR_SAVE_MANY_FAILURE';

export const HOLIDAYCALENDAR_REMOVE: any = 'HOLIDAYCALENDAR_REMOVE';
export const HOLIDAYCALENDAR_REMOVE_QUEUE: any = 'HOLIDAYCALENDAR_REMOVE_QUEUE';
export const HOLIDAYCALENDAR_REMOVE_SUCCESS: any = 'HOLIDAYCALENDAR_REMOVE_SUCCESS';
export const HOLIDAYCALENDAR_REMOVE_FAILURE: any = 'HOLIDAYCALENDAR_REMOVE_FAILURE';

export const HOLIDAYCALENDAR_RESTORE: any = 'HOLIDAYCALENDAR_RESTORE';
export const HOLIDAYCALENDAR_RESTORE_QUEUE: any = 'HOLIDAYCALENDAR_RESTORE_QUEUE';
export const HOLIDAYCALENDAR_RESTORE_SUCCESS: any = 'HOLIDAYCALENDAR_RESTORE_SUCCESS';
export const HOLIDAYCALENDAR_RESTORE_FAILURE: any = 'HOLIDAYCALENDAR_RESTORE_FAILURE';

export const HOLIDAYCALENDAR_RESTORE_MANY: any = 'HOLIDAYCALENDAR_RESTORE_MANY';
export const HOLIDAYCALENDAR_REMOVE_MANY: any = 'HOLIDAYCALENDAR_REMOVE_MANY';

// OWA-1018: settle this tab's pending save of a record
export const HOLIDAYCALENDAR_SAVE_REVERT: any = 'HOLIDAYCALENDAR_SAVE_REVERT';
export const HOLIDAYCALENDAR_PENDING_CHECK: any = 'HOLIDAYCALENDAR_PENDING_CHECK';

/* Fetch actions */
export const fetchHolidayCalendarSuccess = (holidayCalendars: HolidayCalendar[], partial: boolean, lastFetch: number) => ({type: HOLIDAYCALENDAR_FETCH_SUCCESS, holidayCalendars, partial, lastFetch});
export const fetchHolidayCalendarFailure = (err: any) => {
		console.error('HolidayCalendarAction: fetchHolidayCalendarFailure', err);
		return {type: HOLIDAYCALENDAR_FETCH_FAILURE, err};
};
export const fetchOneHolidayCalendarQueue = (holidayCalendarId: string, sentAddedOn?: number) => ({type: HOLIDAYCALENDAR_FETCH_ONE_QUEUE, holidayCalendarId, sentAddedOn});
export const fetchOneHolidayCalendarSuccess = (holidayCalendar: HolidayCalendar | null, sentAddedOn?: number, holidayCalendarId: string = holidayCalendar?.id) => ({type: HOLIDAYCALENDAR_FETCH_ONE_SUCCESS, holidayCalendarId, holidayCalendar, sentAddedOn});
export const fetchOneHolidayCalendarFailure = (id: string, err: any) => {
		console.error('HolidayCalendarAction: fetchOneHolidayCalendarFailure', err);
		return {type: HOLIDAYCALENDAR_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveHolidayCalendar = (holidayCalendar: HolidayCalendar) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE action', holidayCalendar?.id);
    return {type: HOLIDAYCALENDAR_SAVE, holidayCalendar};
}
export const saveHolidayCalendarQueue = (holidayCalendar: HolidayCalendar, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_QUEUE action', holidayCalendar?.id);
    return {type: HOLIDAYCALENDAR_SAVE_QUEUE, holidayCalendar, onQueued};
}
export const saveHolidayCalendarSuccess = (holidayCalendar: HolidayCalendar, sentAddedOn?: number) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_SUCCESS action', holidayCalendar?.id);
    return {type: HOLIDAYCALENDAR_SAVE_SUCCESS, holidayCalendar, sentAddedOn};
}
export const saveHolidayCalendarFailure = (holidayCalendar: HolidayCalendar, status: number, message: string) => {
    console.warn(`⮂ HOLIDAYCALENDAR_SAVE_FAILURE error saving holidayCalendar: HTTP ${status}: ${message}`, holidayCalendar?.id);
    return {type: HOLIDAYCALENDAR_SAVE_FAILURE, holidayCalendar, status, message};
};

/* SaveMany actions */
export const saveManyHolidayCalendars = (holidayCalendars: HolidayCalendar[]) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_MANY action', holidayCalendars?.map(holidayCalendar => holidayCalendar?.id).join(','));
    return {type: HOLIDAYCALENDAR_SAVE_MANY, holidayCalendars};
}
export const saveManyHolidayCalendarsQueue = (holidayCalendars: HolidayCalendar[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_MANY_QUEUE action', holidayCalendars?.map(holidayCalendar => holidayCalendar.id).join(','));
    return {type: HOLIDAYCALENDAR_SAVE_MANY_QUEUE, holidayCalendars, onQueued};
}

/** `sentAddedOns`: the queue key each answer acknowledges, aligned with `holidayCalendars` (OWA-1018) */
export const saveManyHolidayCalendarsSuccess = (holidayCalendars: HolidayCalendar[], sentAddedOns?: (number | undefined)[]) => {
    // console.debug('⮂ HOLIDAYCALENDAR_SAVE_MANY_SUCCESS action', holidayCalendars?.map(holidayCalendar => holidayCalendar.id).join(','));
    return {type: HOLIDAYCALENDAR_SAVE_MANY_SUCCESS, holidayCalendars, sentAddedOns};
}
export const saveManyHolidayCalendarsFailure = (holidayCalendars: HolidayCalendar[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_HOLIDAYCALENDARS_FAILURE Error saving holidayCalendars: HTTP ${status}: ${message}`, holidayCalendars?.map(holidayCalendar => holidayCalendar.id).join(','));
		return {type: HOLIDAYCALENDAR_SAVE_MANY_FAILURE, holidayCalendars, status, message};
};

/* Remove actions */
export const removeHolidayCalendar = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_REMOVE, holidayCalendar });
export const removeHolidayCalendarQueue = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_REMOVE_QUEUE, holidayCalendar });
export const removeHolidayCalendarSuccess = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_REMOVE_SUCCESS, holidayCalendar });
export const removeHolidayCalendarFailure = (holidayCalendar: HolidayCalendar, status: number, message: string) => {
	console.error(`Redux: removeHolidayCalendarFailure Error removing holidayCalendar: HTTP ${status}: ${message}`);
	return ({ type: HOLIDAYCALENDAR_REMOVE_FAILURE, holidayCalendar, status, message });
};

/* Restore actions */
export const restoreHolidayCalendar = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_RESTORE, holidayCalendar });
export const restoreHolidayCalendarQueue = (holidayCalendar: HolidayCalendar) => ({ type: HOLIDAYCALENDAR_RESTORE_QUEUE, holidayCalendar });
export const restoreHolidayCalendarSuccess = (holidayCalendar: HolidayCalendar, sentAddedOn?: number) => ({ type: HOLIDAYCALENDAR_RESTORE_SUCCESS, holidayCalendar, sentAddedOn });
export const restoreHolidayCalendarFailure = (holidayCalendar: HolidayCalendar, status: number, message: string) => {
	console.error(`Redux: restoreHolidayCalendarFailure Error restoring holidayCalendar: HTTP ${status}: ${message}`);
	return ({ type: HOLIDAYCALENDAR_RESTORE_FAILURE, holidayCalendar, status, message });
};

/* RestoreMany actions */
export const restoreManyHolidayCalendars = (holidayCalendars: HolidayCalendar[]) => ({ type: HOLIDAYCALENDAR_RESTORE_MANY, holidayCalendars });

/* RemoveMany actions */
export const removeManyHolidayCalendars = (holidayCalendars: HolidayCalendar[]) => ({ type: HOLIDAYCALENDAR_REMOVE_MANY, holidayCalendars });

/* Pending save actions (OWA-1018) */
/**
 * The save `holidayCalendar` (queue key `sentAddedOn`, default its addedOn) will not be accepted: it was
 * refused, or never reached the queue. Its row returns to the latest accepted version, or to
 * `current` (the record as the server holds it) when that is newer; `keep` leaves the row shown.
 */
export const revertHolidayCalendarSave = (holidayCalendar: HolidayCalendar, options: {sentAddedOn?: number, current?: HolidayCalendar | null, keep?: boolean} = {}) =>
    ({type: HOLIDAYCALENDAR_SAVE_REVERT, holidayCalendar, ...options});
/** processQueue read the shared queue at `readAt` (performance.now()): the live and the permanently refused queue keys */
export const checkHolidayCalendarPendingSaves = (live: number[], refused: number[], readAt: number) =>
    ({type: HOLIDAYCALENDAR_PENDING_CHECK, live, refused, readAt});